/**
 * Create a warehouse key combining division and warehouse number
 * Used as a unique identifier for warehouse options
 * @param division - Division identifier
 * @param warehouse - Warehouse number
 * @returns Formatted key like "DIV_123"
 */
export function getWarehouseKey(division: string, warehouse: number): string {
  return `${division}_${String(warehouse)}`;
}
